export const disabledInput = {
  backgroundColor: 'rgb(224,224,224)',
  color: 'grey',
};
